/**
 * /frontend/src/features/analytics/api/staffingAnalyticsApi.js
 */

import { ANALYTICS_ENDPOINTS } from '../constants/analyticsEndpoints';
import { getJson } from './analyticsApiClient';

/**
 * Fetches staffing forecast.
 */
export const getStaffingForecast = async (request, token, storeId, days) => getJson(
  request,
  ANALYTICS_ENDPOINTS.STAFFING_FORECAST,
  { storeId, days },
  token,
  'analytics-staffing-forecast'
);

/**
 * Fetches staffing efficiency.
 */
export const getStaffingEfficiency = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.STAFFING_EFFICIENCY,
  { storeId, startDate, endDate },
  token,
  'analytics-staffing-efficiency'
);

/**
 * Fetches staffing schedule recommendation for a date.
 */
export const getStaffingScheduleRecommendation = async (request, token, storeId, date) => getJson(
  request,
  ANALYTICS_ENDPOINTS.STAFFING_SCHEDULE_RECOMMENDATION,
  { storeId, date },
  token,
  'analytics-staffing-schedule-recommendation'
);

